<template>
    <el-form ref="form" v-if="location == 'alert'" v-model="dataObjVal" label-width="80px" label-position="right">
        <el-row :gutter="20">
            <template v-for="(val1, key1) in searchs" :key="key1">
                <template v-if="!val1.hiden && (!val1.location || val1.location == location)">

                    <el-col :span="6" v-if="val1.way == 'eq'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-select 
                                v-model="dataObjVal[key1]" 
                                :placeholder="val1.name" 
                                style="width: 100%;"
                                @change="setVal"
                                clearable
                            >
                                <el-option label="空" value="" />
                                <el-option v-for="(val2, key2) in val1.data" :key="key2" :label="val2" :value="key2" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'in'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-select 
                                v-model="dataObjVal[key1]" 
                                :placeholder="val1.name" 
                                style="width: 100%;" 
                                multiple 
                                collapse-tags
                                @change="setVal"
                            >
                                <el-option label="空" value="" />
                                <el-option v-for="(val2, key2) in val1.data" :key="key2" :label="val2"
                                    :value="key2" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'types'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <goodsType v-model:valueId="dataObjVal[key1]" :is_all="true" @typeChange="setVal"></goodsType>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'like'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-input 
                                v-if="val1.type == 'number'" 
                                type="number" 
                                v-model="dataObjVal[key1]"
                                :placeholder="val1.name" 
                                @change="setVal"
                                style="width: 100%;" 
                            />
                            <el-input 
                                v-else 
                                v-model="dataObjVal[key1]" 
                                :placeholder="val1.name" 
                                @change="setVal"
                                style="width: 100%;" 
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'number'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-input 
                                type="number" 
                                v-model="dataObjVal[key1]" 
                                :placeholder="val1.name" 
                                @change="setVal"
                                style="width: 100%;" 
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'dataTime_qujian'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-date-picker 
                                v-model="dataObjVal[key1]" 
                                type="datetimerange" 
                                start-placeholder="开始日期时间"
                                end-placeholder="结束日期时间" 
                                format="YYYY-MM-DD HH:mm:ss" 
                                date-format="YYYY-MM-DD"
                                time-format="hh:mm:ss" 
                                value-format="YYYY-MM-DD HH:mm:ss" 
                                @change="setVal"
                                style="width: 100%;" 
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'data_qujian'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-date-picker 
                                v-model="dataObjVal[key1]" 
                                type="daterange" 
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" 
                                date-format="YYYY-MM-DD" 
                                value-format="YYYY-MM-DD" 
                                @change="setVal"
                                style="width: 100%;" 
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'batch_qujian'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-date-picker 
                                v-model="dataObjVal[key1]" 
                                type="daterange" 
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" 
                                date-format="YYYY-MM-DD" 
                                value-format="YYYY-MM-DD" 
                                @change="setVal"
                                style="width: 100%;" 
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'batch'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-date-picker 
                                v-model="dataObjVal[key1]" 
                                type="date" 
                                placeholder="选择日期"
                                date-format="YYYY-MM-DD" 
                                value-format="YYYY-MM-DD" 
                                @change="setVal"
                                style="width: 100%;" 
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" v-else-if="val1.way == 'sum_max_min'">
                        <el-form-item :label="location != 'twoRight' ? val1.name : ''">
                            <el-row>
                                <el-col :span="10">
                                    <el-input-number 
                                        v-model="dataObjVal[key1].min" 
                                        placeholder="最小值为0则不限"
                                        style="width: 100%;" 
                                        @change="setVal"
                                    />
                                </el-col>
                                <el-col :span="4" style="text-align: center;">
                                    --
                                </el-col>
                                <el-col :span="10">
                                    <el-input-number 
                                        v-model="dataObjVal[key1].max" 
                                        placeholder="最大值为0则不限"
                                        style="width: 100%;" 
                                        @change="setVal"
                                    />
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>

                </template>
            </template>
        </el-row>
    </el-form>

    <el-form ref="form" v-else class="df jcfs aic fww" v-model="dataObjVal" label-width="80px" label-position="right">
        <template v-for="(val1, key1) in searchs" :key="key1">
            <template v-if="!val1.hiden && val1.location && val1.location == location">

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-if="val1.way == 'eq'" style="width: 250px;">
                    <el-select 
                        v-model="dataObjVal[key1]" 
                        :placeholder="val1.name" 
                        style="width: 100%;min-width:150px;"
                        @change="setVal"
                        clearable
                    >
                        <el-option label="空" value="" />
                        <el-option v-for="(val2, key2) in val1.data" :key="key2" :label="val2" :value="key2" />
                    </el-select>
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'in'" style="width: 250px;">
                    <el-select 
                        v-model="dataObjVal[key1]" 
                        :placeholder="val1.name" 
                        style="width: 100%;min-width:150px;" 
                        multiple 
                        collapse-tags
                        @change="setVal"
                    >
                        <el-option label="空" value="" />
                        <el-option v-for="(val2, key2) in val1.data" :key="key2" :label="val2" :value="key2" />
                    </el-select>
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'types'" style="width: 250px;">
                    <goodsType v-model:valueId="dataObjVal[key1]" :is_all="true" @typeChange="setVal"></goodsType>
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'like'" style="width: 250px;">
                    <el-input 
                        v-if="val1.type == 'number'" 
                        type="number" 
                        v-model="dataObjVal[key1]"
                        :placeholder="val1.name" 
                        @change="setVal"
                        style="width: 100%;min-width:150px;" 
                    />
                    <el-input 
                        v-else 
                        v-model="dataObjVal[key1]" 
                        :placeholder="val1.name" 
                        @change="setVal"
                        style="width: 100%;min-width:150px;" 
                    />
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'number'" style="width: 250px;">
                    <el-input 
                        type="number" 
                        v-model="dataObjVal[key1]" 
                        :placeholder="val1.name" 
                        @change="setVal"
                        style="width: 100%;min-width:150px;" 
                    />
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'dataTime_qujian'" style="width: 250px;">
                    <el-date-picker 
                        v-model="dataObjVal[key1]" 
                        type="datetimerange" 
                        start-placeholder="开始日期时间"
                        end-placeholder="结束日期时间" 
                        format="YYYY-MM-DD HH:mm:ss" 
                        date-format="YYYY-MM-DD"
                        time-format="hh:mm:ss" 
                        value-format="YYYY-MM-DD HH:mm:ss" 
                        @change="setVal"
                        style="width: 100%;min-width:150px;" 
                    />
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'data_qujian'" style="width: 250px;">
                    <el-date-picker 
                        v-model="dataObjVal[key1]" 
                        type="daterange" 
                        start-placeholder="开始日期"
                        end-placeholder="结束日期" 
                        date-format="YYYY-MM-DD" 
                        value-format="YYYY-MM-DD" 
                        @change="setVal"
                        style="width: 100%;min-width:150px;" 
                    />
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'batch_qujian'" style="width: 250px;">
                    <el-date-picker 
                        v-model="dataObjVal[key1]" 
                        type="daterange" 
                        start-placeholder="开始日期"
                        end-placeholder="结束日期" 
                        date-format="YYYY-MM-DD" 
                        value-format="YYYY-MM-DD" 
                        @change="setVal"
                        style="width: 100%;min-width:150px;" 
                    />
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'batch'" style="width: 250px;">
                    <el-date-picker 
                        v-model="dataObjVal[key1]" 
                        type="date" 
                        placeholder="选择日期"
                        date-format="YYYY-MM-DD" 
                        value-format="YYYY-MM-DD" 
                        @change="setVal"
                        style="width: 100%;min-width:150px;" 
                    />
                </el-form-item>

                <el-form-item :label="location != 'twoRight' ? val1.name : ''" v-else-if="val1.way == 'sum_max_min'" style="width: 250px;">
                    <el-row>
                        <el-col :span="10">
                            <el-input-number 
                                v-model="dataObjVal[key1].min" 
                                placeholder="最小值为0则不限"
                                style="width: 100%;min-width:150px;" 
                                @change="setVal"
                            />
                        </el-col>
                        <el-col :span="4" style="text-align: center;">
                            --
                        </el-col>
                        <el-col :span="10">
                            <el-input-number 
                                v-model="dataObjVal[key1].max" 
                                placeholder="最大值为0则不限"
                                style="width: 100%;min-width:150px;" 
                                @change="setVal"
                            />
                        </el-col>
                    </el-row>
                </el-form-item>

                

            </template>
        </template>

        <slot name="buttom">

        </slot>
    </el-form>
</template>

<script>
import goodsType from '@/components/coom/tree/goodsType.vue'
export default {
    name: 'mianPageSearchs',

    components: {
        goodsType
    },

	watch: {
        searchs(){

        },

        dataObj(newObj){
            console.log('sss')
            this.dataObjVal = newObj
        }
    },

    props: {
        searchs:{
            type:Object,
            default:() => {}
        },

        dataObj:{
            type:Object,
            default:() => {}
        },

        location:{
            type:String,
            default:'alert'
        }
    },

    data() {

        console.log('筛选条件',this.dataObj)
        
        // this.searchs.forEach(val => {
        //     if(val.way == 'in'){
        //         console.log('搜索条件',val)
        //     }
        // })

        return {
            dataObjVal:this.dataObj,
        }
    },

    created() { },

    methods: {

        setVal() {

            this.$emit('update:dataObj', this.dataObjVal);
            this.$emit('change', this.dataObjVal);
            
        },

    }
}
</script>

<style lang="less">

.mianPageSearchs{
    

}

</style>